import { render } from "./SleepInfo.vue?vue&type=template&id=6806bd92"
import script from "./SleepInfo.vue?vue&type=script&lang=js"
export * from "./SleepInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__